<template>
   
        <article class="bubble" v-if="ready" :style="getPopupPosition">
            <h3>{{properties.title}}</h3>
            <div v-html="properties.text"></div>
            <button class="bubble__close" @click="closeComponent()">
                <img src="@/assets/img/ui/close_black.svg">
            </button>
        </article>
 
</template>


<script>

export default {

    props: [
        "properties",
        "pageData",
        "activeHotspots",
        "slug",
         "children"
    ],
    data() {
        return {
            ready: false,
            positionData: {},
        }
    },
    created() {

    },
    mounted() {
        setTimeout(() => {
            this.positionData = this.activeHotspots.find(hotspot => hotspot.slug === this.slug).data.positionData;
            this.ready = true;
        }, 100);
    },
    methods: {

        closeComponent() {
            this.$emit("closeComponent", this.slug)
        },

        getSrc(src) {
            return app.api.Utils.getMediaPath(src);
        }
    },
    computed: {
   
        getPopupPosition() {
            console.log(this.positionData)
            let offsetY = -16;
            let offsetX = -15;
            // let responsiveOffsets = this.$store.getters.getOffsetValue;

            return {
                left: (this.positionData.xPosition + offsetX) + 'px',
                top: (this.positionData.yPosition + offsetY) + 'px'
            }
        },
    }
       
};

</script>
<style lang="scss">

.bubble {
    width:330px;
    height:330px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border-radius: 50%;
    padding:40px;
    background-color: #fff;

    h3 {
        font-size:30px;
        margin-bottom:1em;
    }
    div {
        font-size: 14px;
    }

    .bubble__close {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        width:60px;
        height:60px;
        background-color: var(--main-color);
        border-radius: 50%;
        top:10px;
        left:10px;

        &>img {
            width:50%;  
        }
    }
}


</style>